<div class="auth-page">
  <!-- Left Side - Branding -->
  <div class="auth-hero">
    <div class="auth-hero__icons">
      <i class="pi pi-building hero-icon hero-icon--1"></i>
      <i class="pi pi-chart-bar hero-icon hero-icon--2"></i>
      <i class="pi pi-briefcase hero-icon hero-icon--3"></i>
      <i class="pi pi-bolt hero-icon hero-icon--4"></i>
      <i class="pi pi-cog hero-icon hero-icon--5"></i>
      <i class="pi pi-chart-line hero-icon hero-icon--6"></i>
      <i class="pi pi-box hero-icon hero-icon--7"></i>
      <i class="pi pi-truck hero-icon hero-icon--8"></i>
      <i class="pi pi-wallet hero-icon hero-icon--9"></i>
      <i class="pi pi-file hero-icon hero-icon--10"></i>
      <i class="pi pi-users hero-icon hero-icon--11"></i>
      <i class="pi pi-globe hero-icon hero-icon--12"></i>
    </div>
    <div class="auth-hero__content">
      <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" class="auth-hero__logo" />
      <h1 class="auth-hero__title">Meine Kommune Business Hub</h1>
      <p class="auth-hero__subtitle">Nachhaltige Lösungen für Ihr Unternehmen. Verwalten Sie Ihre Energie, optimieren Sie Prozesse und erreichen Sie Ihre Klimaziele.</p>
    </div>
    <div class="auth-hero__footer">
      <span>Meine Kommune</span>
    </div>
  </div>

  <!-- Right Side - Status Card -->
  <div class="auth-card">
    <div class="auth-card__scroll">
      <!-- Mobile Header -->
      <div class="auth-card__mobile-header">
        <img src="assets/icon/meine-kommune-logo.svg" alt="Meine Kommune" class="auth-card__mobile-logo" />
        <p class="auth-card__mobile-brand">Meine Kommune</p>
        <h1 class="auth-card__mobile-title">Business Hub</h1>
      </div>

      <div class="auth-status">
        <div class="auth-status__icon">
          <i class="pi pi-clock"></i>
        </div>

        <h2 class="auth-status__title">Warten auf Freigabe</h2>

        <p class="auth-status__message">
          Hallo <strong>{{ userName }}</strong>,<br><br>
          Ihr Account wurde erfolgreich erstellt und wartet nun auf die Freigabe durch einen Administrator.
          Sie erhalten eine E-Mail, sobald Ihr Account freigeschaltet wurde.
        </p>

        <div class="auth-status__info">
          <p class="auth-status__info-title">
            <i class="pi pi-info-circle"></i>
            Was passiert als Nächstes?
          </p>
          <ul>
            <li>Ein Administrator prüft Ihre Registrierung</li>
            <li>Sie erhalten eine Benachrichtigung per E-Mail</li>
            <li>Nach der Freigabe können Sie sich anmelden</li>
          </ul>
        </div>

        <div class="auth-status__actions">
          <button class="auth-btn" (click)="checkStatus()" [disabled]="isChecking">
            <i *ngIf="!isChecking" class="pi pi-refresh"></i>
            <i *ngIf="isChecking" class="pi pi-spinner pi-spin"></i>
            <span>Status überprüfen</span>
          </button>

          <button class="auth-btn auth-btn--outline" (click)="logout()">
            <i class="pi pi-sign-out"></i>
            <span>Abmelden</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
